import { OnboardingWizard } from '@/features/onboarding/OnboardingWizard'

export function OnboardingPage() {
  return <OnboardingWizard />
}
